module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formInput">\r\n	<label>Туристы</label>\r\n	<i class="icon icon-i16_who2"></i>\r\n	<div class="formInputPlace">\r\n		<p></p>\r\n		<span></span>\r\n	</div>\r\n</div>\r\n<div class="formDropdownContent">\r\n	<div class="touristGroup">\r\n		<div class="touristGroup__container">\r\n			<div class="touristGroup__label">\r\n				<i class="icon-i16_adult-2"></i> <span>Взрослые</span>\r\n			</div>\r\n			<div class="touristGroup__content">\r\n				<div class="adults__buttonset">\r\n					';
 for (var i = 1; i <= 4; i++) { 
__p+='\r\n					<input type="radio" name="adults" value="'+
((__t=( i ))==null?'':__t)+
'"\r\n						   id="adults__buttonset_'+
((__t=( cid + i ))==null?'':__t)+
'"><label\r\n						for="adults__buttonset_'+
((__t=( cid + i ))==null?'':__t)+
'">'+
((__t=( i ))==null?'':__t)+
'</label>\r\n					';
 } 
__p+='\r\n				</div>\r\n			</div>\r\n			<div class="touristGroup__label">\r\n				<i class="icon-i16_children"></i> <span>дети</span>\r\n			</div>\r\n			<div class="touristGroup__content">\r\n				<div class="js-collection"></div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n';
}
return __p;
};
